module.exports = __webpack_public_path__ + "static/img/C (31).fe0ed37e.png";